import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AuthStore, BookingStore, Platform } from '@store';

@Component({
  selector: 'app-upgrade-package-box',
  templateUrl: './upgrade-package-box.component.html',
  styleUrls: ['./upgrade-package-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradePackageBoxComponent {
  @Input() boilerSerial: string;

  constructor(
    private router: Router,
    public authStore: AuthStore,
    public bookingStore: BookingStore
  ) {}

  onBuyPackage(): void {
    this.router.navigate(['/booking'], {
      queryParams: {
        boilerSerial: this.boilerSerial,
        platform: Platform.E3,
      },
    });
  }
}
